export const getPaidPlanById = (state, planId) => state.paidPlans.find(p => p.id === planId);
export const getAllPaidPlans = state => state.paidPlans;
